import type { Moment } from 'moment-timezone';
import type { BoardingOffer } from 'model/Service';

/** Noches de estadía (check-in / check-out por día calendario, mínimo 1). */
export function getBoardingStayNightsCount(date?: Moment, dateEnd?: Moment): number {
    if (date?.isValid?.() !== true || dateEnd?.isValid?.() !== true) {
        return 1;
    }
    return Math.max(1, dateEnd.clone().startOf('day').diff(date.clone().startOf('day'), 'days'));
}

export function getBoardingNightlyPrice(
    servicePrice?: number,
    itemDataPrice?: number,
    selectedOffer?: Pick<BoardingOffer, 'pricePerNight'> | null
): number {
    return Number(selectedOffer?.pricePerNight ?? servicePrice ?? itemDataPrice) || 0;
}

/**
 * Total de estadía para UI y itemData.
 * Con deal: usa offer.total si coincide con las noches actuales; si cambian las fechas, recalcula con precio/noche × noches.
 */
export function getBoardingStayLineTotal(params: {
    date?: Moment;
    dateEnd?: Moment;
    servicePrice?: number;
    itemDataPrice?: number;
    selectedOffer?: Pick<BoardingOffer, 'pricePerNight' | 'total'> | null;
}): number {
    const nights = getBoardingStayNightsCount(params.date, params.dateEnd);
    const nightly = getBoardingNightlyPrice(params.servicePrice, params.itemDataPrice, params.selectedOffer);

    if (params.selectedOffer != null && nightly > 0) {
        const offerNights = Math.max(1, Math.round(params.selectedOffer.total / nightly));
        if (offerNights === nights) {
            return params.selectedOffer.total;
        }
    }

    return nightly * nights;
}

/** Suma de minutos de estadía alineada a noches calendario (para duración en footer). */
export function getBoardingStayDurationMinutes(date?: Moment, dateEnd?: Moment): number {
    return getBoardingStayNightsCount(date, dateEnd) * 24 * 60;
}
